import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { MaintenanceWindow } from '../models/maintenance-window.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private collectionName = 'maintenance-windows';
  private accessGranted = false;

  constructor(private afs: AngularFirestore, private afAuth: AngularFireAuth) {
    this.afAuth.authState.subscribe((user) => {
      if (!user) {
        this.setAccess(false);
      }
    });
  }

  async startWindow(data: MaintenanceWindow) {
    return this.afs.collection<MaintenanceWindow>(this.collectionName).add(data);
  }

  async endWindow(id: string, data: Partial<MaintenanceWindow>) {
    return this.afs.collection(this.collectionName).doc(id).update(data);
  }

  async getActiveWindow(): Promise<MaintenanceWindow | null> {
    const snapshot = await firstValueFrom(
      this.afs
        .collection<MaintenanceWindow>(this.collectionName, (ref) => ref.where('active', '==', true).limit(1))
        .get()
    );

    if (snapshot.empty) return null;

    const doc = snapshot.docs[0];
    return { id: doc.id, ...(doc.data() as MaintenanceWindow) };
  }

  async getHistory(): Promise<MaintenanceWindow[]> {
    const snapshot = await firstValueFrom(
      this.afs.collection<MaintenanceWindow>(this.collectionName, (ref) => ref.orderBy('date', 'desc')).get()
    );

    return snapshot.docs.map((d) => ({
      id: d.id,
      ...(d.data() as MaintenanceWindow),
    }));
  }

  setAccess(granted: boolean) {
    this.accessGranted = granted;
    if (granted) {
      sessionStorage.setItem('maintenance_access', 'true');
    } else {
      sessionStorage.removeItem('maintenance_access');
    }
  }

  hasAccess(): boolean {
    return this.accessGranted || sessionStorage.getItem('maintenance_access') === 'true';
  }
}
